import { ShortcutController } from './shortcutListInterface';
import { ShortcutListViewProps } from './shortcutListProps';
import { ReportingControllerBaseConfig } from '../../../../../base';
import { ShortcutItemViewProps } from '../item';
import { InsertComponentEntity } from '@varos/research-react';

export function createShortcutController(
    config: ReportingControllerBaseConfig
): ShortcutController {
    // Maximum number of shortcuts to show inline before collapsing into "more"
    const maxInlineShortcuts = 4;
    return {
        useProps(context, data, props): ShortcutListViewProps {
            const { onComponentCreate, loadingComponentId } = props;

            // Map components to shortcut items
            const shortcuts = data.components.map((component) => {
                return {
                    id: component.id,
                    name: component.name,
                    description: component.description,
                    kind: component.kind,
                    icon: {
                        kind: 'emoji' as const,
                        value: component.icon,
                    },
                    component,
                };
            });

            const inline = shortcuts.slice(0, maxInlineShortcuts);
            const more = shortcuts.slice(maxInlineShortcuts);

            return {
                items: inline.map(
                    (shortcut): ShortcutItemViewProps => ({
                        id: shortcut.id,
                        label: shortcut.name,
                        description: shortcut.description,
                        tooltip: {
                            label: shortcut.component.summary,
                        },
                        icon: shortcut.icon,
                        button: {
                            onClick: () => onComponentCreate(shortcut.component),
                            isLoading: loadingComponentId === shortcut.component.id,
                        },
                    })
                ),
                truncated:
                    more.length === 0
                        ? null
                        : {
                              items: more.map((shortcut) => ({
                                  id: shortcut.id,
                                  label: shortcut.name,
                                  description: shortcut.description,
                                  tooltip: {
                                      label: shortcut.component.summary,
                                  },
                                  icon: shortcut.icon,
                                  button: {
                                      onClick: () =>
                                          onComponentCreate(shortcut.component),
                                      isLoading:
                                          loadingComponentId === shortcut.component.id,
                                  },
                              })),
                          },
            };
        },
    };
}
